// Espelho (transversal/at-87): PRECISA ser o primeiro import — ver src/espelho/instalar.ts.
import './espelho/instalar';
import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import './shared/tema/tema.css';
// O overlay de TODOS os modais (at-95): declarado só ali e importado aqui, uma vez, para nenhum
// modal depender de o CSS de outra tela estar no bundle (BUG-V74).
import './shared/ui/modal-overlay.css';
import { iniciarTema } from './shared/tema/tema';
import App from './App';
import reportWebVitals from './reportWebVitals';
import attachAuthToken from './api/axiosConfig';
import NotifyProvider from './shared/feedback/NotifyProvider';
import { register as registrarServiceWorker } from './serviceWorkerRegistration';
import { ESPELHO } from './espelho/ativo';

// No espelho, a barra de troca de papel. A condição é escrita aqui (e não lida de `ESPELHO`)
// para o webpack conseguir eliminar o require do bundle de produção.
const BarraEspelho =
  process.env.REACT_APP_ESPELHO === 'true' ? require('./espelho/BarraEspelho').default : null;

// O ToastContainer (e o CSS do react-toastify) vive no NotifyProvider — montar um
// segundo container aqui duplicava todo toast do sistema (BUG-V75).

// Impede que cliques em toasts fechem modais via clickOutside
// (a classe .Toastify continua vindo do container montado pelo NotifyProvider).
//
// SÓ `mousedown`, nunca `click` (previsao-pecas/at-02, 24/10/2026): o React 18 delega os eventos
// para o `#root`, que fica ABAIXO do `document` na fase de captura — parar o `click` aqui impedia o
// `onClick` do X do toast de disparar, e nenhum toast fechava pelo botão (medido com Chrome headless:
// com o listener de `click`, o toast ficava; sem ele, fechava). Os 108 click-outside dos modais
// escutam `mousedown`; o único que escuta `click` (Formulários) ignora o toast por conta própria.
const stopToastPropagation = (event) => {
  if (event.target && typeof event.target.closest === 'function' && event.target.closest('.Toastify')) {
    event.stopPropagation();
  }
};
document.addEventListener('mousedown', stopToastPropagation, true);

attachAuthToken(axios);

// Antes do primeiro render: a tela abre com o último tema conhecido, sem piscar claro.
iniciarTema();

const container = document.getElementById('root');

if (!container) {
  throw new Error('Elemento #root não encontrado');
}

const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <NotifyProvider>
      <App />
      {BarraEspelho && <BarraEspelho />}
    </NotifyProvider>
  </React.StrictMode>
);

reportWebVitals();

/*
  at-114 (ADR 0059): o service worker que faz o aplicativo ABRIR sem rede — sem ele, o trabalho
  offline do inspetor de oficina externa não existe (o IndexedDB não adianta se a página não
  carrega).

  🔴 A versão nova entra SOZINHA (oficina/at-136, 27/10/2026 — reverte o aceite por toast): com
  o aceite, um navegador que nunca clicou ficava dias no bundle antigo. O que estava sendo
  preenchido sobrevive por rascunho (cadastro de veículo e checklist no banco; a visita do
  inspetor no aparelho). Ver `serviceWorkerRegistration.ts`.
*/
// O espelho é publicado em outra origem e não registra o service worker do sistema.
if (!ESPELHO) registrarServiceWorker();
